export type UiEnumOption = {
	value: string;
	label: { en: string; fr: string };
};

export const FONT_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Gotham", label: { en: "Gotham", fr: "Gotham" } },
	{ value: "GothamBold", label: { en: "Gotham Bold", fr: "Gotham Bold" } },
	{ value: "GothamMedium", label: { en: "Gotham Medium", fr: "Gotham Medium" } },
	{ value: "GothamSemibold", label: { en: "Gotham Semibold", fr: "Gotham Semibold" } },
	{ value: "GothamBlack", label: { en: "Gotham Black", fr: "Gotham Black" } },
	{ value: "SourceSans", label: { en: "Source Sans", fr: "Source Sans" } },
	{ value: "SourceSansBold", label: { en: "Source Sans Bold", fr: "Source Sans Bold" } },
] as const;

export const X_ALIGNMENT_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Left", label: { en: "Left", fr: "À gauche" } },
	{ value: "Center", label: { en: "Center", fr: "Au centre" } },
	{ value: "Right", label: { en: "Right", fr: "À droite" } },
] as const;

export const Y_ALIGNMENT_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Top", label: { en: "Top", fr: "En haut" } },
	{ value: "Center", label: { en: "Center", fr: "Au milieu" } },
	{ value: "Bottom", label: { en: "Bottom", fr: "En bas" } },
] as const;

export const LIST_DIRECTION_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Vertical", label: { en: "Top to bottom", fr: "De haut en bas" } },
	{ value: "Horizontal", label: { en: "Left to right", fr: "De gauche à droite" } },
] as const;

export const LIST_ALIGNMENT_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Start", label: { en: "At the start", fr: "Au début" } },
	{ value: "Center", label: { en: "Centered", fr: "Au milieu" } },
	{ value: "End", label: { en: "At the end", fr: "À la fin" } },
] as const;

export const LIST_SORT_OPTIONS: readonly UiEnumOption[] = [
	{ value: "LayoutOrder", label: { en: "Insertion order", fr: "Ordre d'ajout" } },
	{ value: "Name", label: { en: "Alphabetical", fr: "Ordre alphabétique" } },
] as const;

export const GRID_FILL_OPTIONS: readonly UiEnumOption[] = [
	{ value: "Horizontal", label: { en: "Row by row", fr: "Ligne par ligne" } },
	{ value: "Vertical", label: { en: "Column by column", fr: "Colonne par colonne" } },
] as const;

export const GRID_CORNER_OPTIONS: readonly UiEnumOption[] = [
	{ value: "TopLeft", label: { en: "Top left", fr: "Coin haut gauche" } },
	{ value: "TopRight", label: { en: "Top right", fr: "Coin haut droit" } },
	{ value: "BottomLeft", label: { en: "Bottom left", fr: "Coin bas gauche" } },
	{ value: "BottomRight", label: { en: "Bottom right", fr: "Coin bas droit" } },
] as const;

export const TEXT_TRUNCATE_OPTIONS: readonly UiEnumOption[] = [
	{ value: "None", label: { en: "Don't truncate", fr: "Ne pas couper" } },
	{ value: "AtEnd", label: { en: "Truncate with «…»", fr: "Couper avec «…»" } },
] as const;
